

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Config from '@/configuration';

@Component
export default class ExpHookUploadRates extends Vue {
    dialog = false;
    loading = false;

    @Prop()
    id?: number;

    file: any = null;

    toBase64(file: Blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    async Upload() {
        try {
            this.loading = true;

            await fetch(`${Config.host}/api/exp-rates`, {
                method: 'Post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': localStorage.getItem('feathers-jwt') as string
                },
                body: JSON.stringify({
                    hook_id: this.id,
                    data: await this.toBase64(this.file)
                })
            });

            this.file = null;
            this.dialog = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }
}
